import { IEntity } from '../../common/types';
import { ICustomerAttributes } from '../customers/types';

export type TStaffPaths = ['/staff'];

export interface IStaffAttributes {
  full_name: string;
  phone: string;
}

export interface IStaff extends IEntity<'Staff'> {
  attributes: IStaffAttributes;
}

export interface AssignFormAttributes {
  offer_id: string;
  quantity: number;
}

export enum SpecialOfferOwnerEnum {
  STAFF = 'staff',
  CUSTOMER = 'customer',
}

export type AssignOfferPayload = {
  id: string;
  offer_id: string;
  quantity: number;
  owner: SpecialOfferOwnerEnum;
};

export type AssignOffersProps = {
  title: string;
  open: boolean;
  user: ICustomerAttributes['user'];
  owner: SpecialOfferOwnerEnum;
  setOpen: (open: boolean) => void;
};

export type AssignedOfferResponse = {
  offer: string;
  merchant: string;
  quantity: number;
};
